import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/d_left.svg';
import _imports_1 from '@/assets/serviceBtn.png';
const _withScopeId = n => (_pushScopeId("data-v-354037d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "text-[14px] text-white px-[30px] pt-[46px] pb-[20px] max-h-[60vh] relative"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = {
  class: "mx-[14px] text-[18px] text-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-[#F9A51A]"
}, "HH88", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rotate-y-[180deg]"
}, null, -1));
const _hoisted_6 = {
  class: "h-fit text-white px-[30px]"
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "text-right font-bold"
};
const _hoisted_9 = ["src"];
import { Popup as VanPopup, Loading as VanLoading, showToast } from "vant";
import { load } from '@fingerprintjs/fingerprintjs';
import request from "@/utils/request";
import 'vant/es/dialog/style';
import { ref, onMounted, onUnmounted } from "vue";
import MobilePage from "@/components/MobilePage.vue";
import PcPage from "@/components/PcPage.vue";
import PadPage from "@/components/PadPage.vue";
// import {LiveChatWidget, useWidgetIsReady} from "@livechat/widget-vue";
// import {useI18n} from "vue-i18n";
// const isReady = useWidgetIsReady()
// const {locale} = useI18n()
// const livechatIds = {
//     zh_CN: '15165273',
//     zh_TW: '15165273',
//     en_US: '16359324',
//     en_MAS: '16359324',
//     vi_VN: '15165414'
// }

export default {
  __name: 'App',
  setup(__props) {
    /* eslint-disable */
    const innerHeight = ref();
    const isReady = ref(false);
    const visible = ref(false);
    const showService = ref(false);
    ;
    const browserFingerprint = ref('');
    const serviceLink = ref('');
    const clickBack = () => {
      showService.value = false;
    };
    function isTablet() {
      const userAgent = navigator.userAgent.toLowerCase();
      console.log('isTablet', userAgent);
      return /tablet|Macintosh|ipad/i.test(userAgent);
    }
    function handleMessage(event) {
      if (event.data === 'closeChatContainer') {
        showService.value = false;
      }
    }
    onMounted(() => {
      innerHeight.value = window.innerHeight;
      load().then(fp => {
        fp.get().then(result => {
          browserFingerprint.value = result.visitorId;
          const preUrl = process.env.NODE_ENV === 'development' ? '/api' : '';
          request.get(`${preUrl}/c.php?uuid=${browserFingerprint.value}&scene=down_page`).then(({
            data
          }) => {
            serviceLink.value = data.link + '&is_navbar=1';
            isReady.value = true;
          }).catch(err => {
            console.error('getCustomerLink error', err);
            showToast(err?.msg);
          });
        });
      });
      window.addEventListener('message', handleMessage);
      isTablet();
    });
    onUnmounted(() => {
      window.removeEventListener('message', handleMessage);
    });
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.$isMobile() ? (_openBlock(), _createBlock(MobilePage, {
        key: 0,
        onShowDesc: _cache[0] || (_cache[0] = $event => visible.value = true),
        class: "bg-[#1C1C27]"
      })) : isTablet() ? (_openBlock(), _createBlock(PadPage, {
        key: 1,
        onShowDesc: _cache[1] || (_cache[1] = $event => visible.value = true),
        class: "bg-[#1C1C27]"
      })) : (_openBlock(), _createBlock(PcPage, {
        key: 2,
        onShowDesc: _cache[2] || (_cache[2] = $event => visible.value = true)
      })), _createVNode(_unref(VanPopup), {
        show: visible.value,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => visible.value = $event),
        "confirm-button-text": _ctx.$t('confirm'),
        closeable: "",
        class: _normalizeClass([_ctx.$isMobile() ? 'w-[90vw]' : '!w-[40vw]', "!bg-[#232939] rounded-[10px]"])
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: _normalizeClass(["flex justify-center items-center", {
            'whitespace-pre pb-[20px]': !_ctx.$isMobile()
          }])
        }, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.$t('word1')), 1), _hoisted_4]), _hoisted_5], 2)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('word2')), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, _toDisplayString(_ctx.$t('word3')), 1), _createElementVNode("li", null, _toDisplayString(_ctx.$t('word4')), 1), _createElementVNode("li", null, _toDisplayString(_ctx.$t('word5')), 1)]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('word6')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('word7')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('team')), 1)])])]),
        _: 1
      }, 8, ["show", "confirm-button-text", "class"]), _createElementVNode("div", {
        class: _normalizeClass(["absolute", _ctx.$isMobile() ? 'bottom-[10px] right-[10px]' : 'bottom-[120px] right-[70px]'])
      }, [!isReady.value ? (_openBlock(), _createBlock(_unref(VanLoading), {
        key: 0,
        color: "#1989fa"
      })) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _imports_1,
        class: "w-[50px]",
        onClick: _cache[4] || (_cache[4] = $event => showService.value = !showService.value)
      }))], 2), _createVNode(_unref(VanPopup), {
        show: showService.value,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => showService.value = $event),
        style: {
          padding: '0px'
        },
        overlay: false,
        class: _normalizeClass(_ctx.$isMobile() || isTablet() ? '' : 'imPopup')
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "absolute top-[20px] left-[20px]",
          onClick: clickBack
        }, [_createVNode(_component_van_icon, {
          name: "arrow-left",
          size: "25px",
          color: "#d8d8d8"
        })]), showService.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle([{
            "z-index": "1"
          }, _ctx.$isMobile() || isTablet() ? {
            height: `${innerHeight.value}px`,
            width: '100vw',
            overflow: 'hidden'
          } : '']),
          class: _normalizeClass(_ctx.$isMobile() ? '' : 'contentClass')
        }, [serviceLink.value ? (_openBlock(), _createElementBlock("iframe", {
          key: 0,
          scrolling: "no",
          allowtransparency: "true",
          id: "layui-layer-iframe8",
          name: "layui-layer-iframe8",
          frameborder: "0",
          src: serviceLink.value,
          style: {
            "width": "100%",
            "height": "100%"
          }
        }, null, 8, _hoisted_9)) : _createCommentVNode("", true)], 6)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["show", "class"])], 64);
    };
  }
};